'use strict';

import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import bemit from 'Functions/bemit';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import Loader from 'Pure/Loader';
import { SAFERPAY_API, FRONT_ENV } from 'front_env';
import { action } from 'Shared/Routes';
const script_url = SAFERPAY_API + '/Fields/lib/1/saferpay-fields.js';
const {
  app,
  qwest
} = window;
export default class TestSaferPayPaymentKit extends Component {
  state = {
    state: 'start',
    status: {},
    loading_script: false,
    loading: false,
    initializing: false,
    initialized: false
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.loadScriptIfNeeded();
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.state !== prev_state.state) {
      if (state.state === 'fields' && !state.initialized) {
        window.setTimeout(function () {
          component.initFields();
        }, 120);
      }
    }
  }
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const btn_modifiers = ['primary'];
    const init_loader = state.initializing ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary'],
      text: "Chargement des champs..."
    }) : undefined;
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let btn_disabled = false;
    if (state.initializing || state.state === 'fields' && !state.initialized) {
      btn_disabled = true;
    } else if (state.state === 'success') {
      btn_disabled = true;
    }
    if (btn_disabled) btn_modifiers.push('disabled');
    const output = /*#__PURE__*/React.createElement("div", {
      className: "c-form-section u-margin-bottom-20"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-form-section__title"
    }, "Tester le paiement en direct"), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-positioned\r u-padding-top-20 u-padding-bottom-10"
    }, state.state === 'fields' ? /*#__PURE__*/React.createElement("div", {
      className: bemit('c-payment-form', ['test'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__item"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__field",
      id: "fields-holder-name"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__item"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__field",
      id: "fields-card-number"
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__item small"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__field",
      id: "fields-expiration"
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__item small"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__field",
      id: "fields-cvc"
    })))) : undefined, getFormStatus(state.status), /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', btn_modifiers),
      onClick: state.state === 'start' ? e => component.setState({
        state: 'fields'
      }) : e => component.sendTest(),
      disabled: btn_disabled
    }, state.state === 'fields' ? 'Envoyer une demande d\'autorisation de 5€' : 'Tester le kit de paiement', loader), init_loader));
    return output;
  }
  displayFields = () => this.setState({
    state: 'fields'
  });
  initFields = (force = false, retry = 1) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.initialized || !force && state.initializing) return;

    // prevent multiple init calls
    component.setState({
      initializing: true
    });
    const API_CUSTOMER_ID = FRONT_ENV !== 'prod' ? '257543' : props.API_CUSTOMER_ID || '308374';
    const TOKEN = FRONT_ENV !== 'prod' ? 'c94637a6-d7da-4f6b-952e-1332356ab773' : props.API_TOKEN || '807d0232-febf-4be5-8e4b-d741a7f5cad0';
    window.SaferpayFields.init({
      accessToken: TOKEN,
      url: SAFERPAY_API + '/Fields/' + API_CUSTOMER_ID,
      style: {
        '.form-control': 'border: none; border-bottom: solid 1px #ccc; border-radius: unset;'
      },
      paymentMethods: ['visa', 'mastercard'],
      onSuccess: function () {
        component.setState({
          initialized: true,
          initializing: false,
          status: {}
        });
      },
      onError: function (evt) {
        console.error(evt);
        component.setState({
          initialized: false,
          initializing: false,
          status: {
            error: 'Impossible de charger le kit de paiement, ' + 'veuillez réessayer'
          }
        });
      },
      placeholders: {
        // Custom Text for Input placeholders
        holdername: 'Nom du titulaire',
        cardnumber: 'Numéro de la carte',
        expiration: 'MM/YY',
        cvc: 'Code (CVC)'
      }
    });

    // check after 4s, the fields should be ready but sometimes it fails silently
    // (i.e without calling onSuccess or onError)
    window.setTimeout(function () {
      component.checkIfLoaded(retry);
    }, 4000);
  };
  checkIfLoaded = (retry = 1) => {
    const component = this,
      props = this.props,
      state = this.state;

    // Init callback fired
    if (state.initialized) return;
    if (retry > 2) return component.setState({
      initializing: false
    });

    // Init callback not fired after x seconds, trying again
    if (window.SaferpayFields) {
      return component.initFields(true, retry + 1);
    }

    // script loaded but Global object not available, checking later
    window.setTimeout(function () {
      component.checkIfLoaded(retry + 1);
    }, 1000);
  };
  loadScriptIfNeeded = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading_script || window.SaferpayFields) {
      return;
    }

    // prevent multiple script load
    component.setState({
      loading_script: true
    });
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('id', state.script_id);
    script.setAttribute('src', script_url);
    script.addEventListener('load', function () {
      if (!window.SaferpayFields) {
        return window.setTimeout(function () {
          component.setState({
            loading_script: false
          });
        }, 400);
      } else {
        component.setState({
          loading_script: false
        });
      }
    });
    script.addEventListener('onError', function (e, error) {
      console.error('error loading fields script', error);
      component.setState({
        loading_script: false
      });
      component.setState({
        status: {
          error: 'Impossible de charger le kit de paiement.'
        }
      });
    });
    document.body.appendChild(script);
  };
  sendTest = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      status: {},
      loading: true
    });

    // Send the entered hosted fields data to Saferpay.
    window.SaferpayFields.submit({
      onSuccess: function (evt) {
        component.setState({
          loading: true
        });
        qwest.post(action('TestSaferPay'), {
          token: evt?.token,
          id: props.etablishment
        }).then(function (xhr, response) {
          component.setState({
            state: 'success',
            status: {
              info: 'Test réussi. Vous n\'avez pas été prélevé, ' + 'le paiement a été initié mais a été annulé ' + 'avant d\'être finalisé.'
            },
            loading: false
          });
        }).catch(function (error, xhr, response) {
          console.error(response?.error || response?.raw || error);
          component.setState({
            status: response,
            loading: false
          });
        });
      },
      onError: function (evt) {
        const validation_error = evt?.message?.includes('fields contains invalid or missing data');
        const error = validation_error ? 'Les informations saisies sont incorrectes, veuillez' + ' vérifier votre saisie.' : 'Échec du paiement, veuillez réessayer.';
        component.setState({
          status: {
            error: error
          },
          loading: false
        });
      }
    });
  };
}
